import { render } from "./permissions.vue?vue&type=template&id=1a4bba3a&scoped=true&lang=pug"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"

import "./permissions.vue?vue&type=style&index=0&id=1a4bba3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4bba3a"]])

export default __exports__